import moment from "moment";

const validPeriods = ["day", "week", "month", "quarter", "year"];

export default function cannedDateRanges(bounds) {
    const ranges = {};

    function addRange(period, name, startMoment, endMoment, preferred) {
        const startKey = startMoment.format("YYYY-MM-DD"),
            endKey = endMoment.format("YYYY-MM-DD"),
            key = `${startKey}/${endKey}`;

        const current = ranges[period] || [];

        current.push({
            key,
            name,
            start: startKey,
            end: endKey,
            preferred
        });

        ranges[period] = current;
    }

    validPeriods.map(period => {
        const { firstDate, lastDate, periodCount } = bounds?.[period] ?? {},
            first = moment(firstDate),
            last = moment(lastDate);

        switch (period) {
            case "day": {
                addRange(period, "Last 7 days", last.clone().subtract(6, period), last);
                addRange(period, "Last 30 days", last.clone().subtract(29, period), last);
                addRange(period, "Last 90 days", last.clone().subtract(89, period), last, true);
                addRange(period, "Last 180 days", last.clone().subtract(179, period), last);
                addRange(period, "Year-to-date", last.clone().startOf("year"), last);
                break;
            }
            case "week": {
                addRange(period, "Last 8 weeks", last.clone().subtract(7, period), last);
                addRange(period, "Last 16 weeks", last.clone().subtract(15, period), last);
                addRange(period, "Last 52 weeks", last.clone().subtract(51, period), last, true);
                addRange(period, "Year-to-date", last.clone().startOf("year"), last);
                break;
            }
            case "month": {
                addRange(period, "Last 6 months", last.clone().subtract(5, period), last);
                addRange(period, "Last 12 months", last.clone().subtract(11, period), last);
                addRange(period, "Last 48 months", last.clone().subtract(47, period), last);
                addRange(period, "Year-to-date", last.clone().startOf("year"), last);
                break;
            }
            case "quarter": {
                addRange(period, "Last 4 quarters", last.clone().subtract(3, period), last);
                addRange(period, "Last 8 quarters", last.clone().subtract(7, period), last);
                addRange(period, "Last 12 quarters", last.clone().subtract(11, period), last);
                addRange(period, "Year-to-date", last.clone().startOf("year"), last);
                break;
            }
        }
        if (periodCount > 0) addRange(period, "All time", first, last);

        // cache the preferred range for each period
        let range;
        if (ranges[period]) {
            for (let i = 0; i < ranges[period].length; ++i) {
                range = ranges[period][i];
                if (range.preferred) break;
            }
            ranges[period].preferred = range;
        }
    });
    return ranges;
}
